import { render, staticRenderFns } from "./P2PDiscussion.vue?vue&type=template&id=49b6bd44&scoped=true"
import script from "./P2PDiscussion.vue?vue&type=script&lang=js"
export * from "./P2PDiscussion.vue?vue&type=script&lang=js"
import style0 from "./P2PDiscussion.vue?vue&type=style&index=0&id=49b6bd44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b6bd44",
  null
  
)

export default component.exports